<template>
  <div class="title">
      <img :src="url" class="icon" v-if="url" />
      <span> {{title}} </span>
    </div>
</template>

<script>
export default {
  props: ["title","url"],
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.title {
   -webkit-animation: scale-in-hor-center 0.6s
        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
      animation: scale-in-hor-center 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)
        both;
    width: 56%;
    border: solid 1px #dca74e;
    margin: 87px auto 20px;
    padding: 5px 0px;
    .icon {
      width: 24px;
      margin-top: 8px;
      margin-left: 27px;
    }
    span {
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 1px;
      color: #333333;
      position: relative;
      top: -4px;
      left: 1%;
    }
  }

</style>